import { useState } from "react";
import cancelImage from "../assets/images/cancel.png";
import {
	useEditTodoColorMutation,
	useEditTodoStatusMutation,
	useDeleteTodoMutation,
	useEditTodoMutation,
} from "../features/api/apiSlice";

export default function Todo({ todo }) {
	const { text, id, completed, color } = todo;
	const [edit, setEdit] = useState(false);
	const [updatedText, setUpdatedText] = useState(text);

	const [editTodoColor] = useEditTodoColorMutation();
	const [editTodoStatus] = useEditTodoStatusMutation();
	const [deleteTodo] = useDeleteTodoMutation();
	const [editTodo] = useEditTodoMutation();

	const handleStatusChange = (todoId) => {
		editTodoStatus({
			id: todoId,
			data: {
				completed: !completed,
			},
		});
	};

	const handleColorChange = (todoId, color) => {
		editTodoColor({
			id: todoId,
			data: {
				color: color,
			},
		});
	};

	const handleDelete = (todoId) => {
		deleteTodo({
			id: todoId,
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		editTodo({
			id: id,
			data: {
				text: updatedText,
			},
		});
		setEdit(false);
	};

	return (
		<div className="flex flex-col space-y-4 justify-between md:space-y-0 md:flex-row md:justify-start md:items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
			<div className="flex flex-1 items-center">
				<div
					className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-3 ${
						completed && "border-green-500 focus-within:border-green-500"
					}`}
				>
					<input
						type="checkbox"
						checked={completed}
						onChange={() => handleStatusChange(id)}
						className="opacity-0 absolute rounded-full"
					/>
					{completed && (
						<svg
							className="fill-current w-3 h-3 text-green-500 pointer-events-none"
							viewBox="0 0 20 20"
						>
							<path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
						</svg>
					)}
				</div>

				<div
					className={`${edit && "hidden "} py-1 select-none flex-1 ${
						completed && "line-through"
					}`}
				>
					{text}
				</div>
				<div className={`${!edit && "hidden "} w-full md:flex-1`}>
					<form onSubmit={handleSubmit}>
						<input
							type="text"
							name=""
							id=""
							className="w-full border h-full px-2 py-1 focus:border-0  focus:ring-1 focus-outline-none focus:ring-gray-100"
							value={updatedText}
							onChange={(e) => setUpdatedText(e.target.value)}
						/>
					</form>
				</div>
			</div>

			<div className="flex gap-2 items-center pr-2">
				<div
					className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
						color === "green" && "bg-green-500"
					}`}
					onClick={() => handleColorChange(id, "green")}
				></div>

				<div
					className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
						color === "yellow" && "bg-yellow-500"
					}`}
					onClick={() => handleColorChange(id, "yellow")}
				></div>

				<div
					className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
						color === "red" && "bg-red-500"
					}`}
					onClick={() => handleColorChange(id, "red")}
				></div>

				{!completed && (
					<div onClick={() => setEdit(!edit)}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth="1.5"
							stroke="currentColor"
							className="flex-shrink-0 w-5 h-5 ml-2 cursor-pointer"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
							/>
						</svg>
					</div>
				)}

				<div className="">
					<img
						src={cancelImage}
						className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
						alt="Cancel"
						onClick={() => handleDelete(id)}
					/>
				</div>
			</div>
		</div>
	);
}
